import React, {useEffect, useState} from "react";
import Paper from '@material-ui/core/Paper';
import clienteAxios from "../../../service/axios";
import WidgetBateria from "../../widget/Bateria"
import { Grid } from "@material-ui/core";
import CircularProgress from '@material-ui/core/CircularProgress';

export default function BatteryInfo({ rowData }) {
    const [battery, setBattery] = useState()
    const [carga, setCarga] = useState(true)
    const init = async() => {
        let array = [];
        let resultado;
        resultado = await clienteAxios.get(`/registros/nodos?numeroSerie=${rowData.numeroSerie}`,
            {
                params: {
                    limite: 1,
                },
            }
        );
        if (resultado.data){
            array= resultado.data            
        }
        return array
    }
    //M:0,B:953
    
    const filter = (data) => {
        let battery
        setCarga(data.bateria)
        if (data.registros.length>0 && data.registros[0].lecturas){
            data.registros[0].lecturas.map(d => {
                
                /* if(!battery && d.data !== "M:0" && d.data !== "M:1"){
                    battery= d.data
                } */
                if (d.nombreVariable==="Bateria"){
                    if (d.estadoBateria){ 
                        battery= d.estadoBateria
                        setBattery(battery)
                    }
                }

            })
        }
        /*  if (battery){
           battery=battery.split(":", 3)[2] 
           console.log('batmananana', battery)
            setBattery(((battery-890)*100/75) )
        }*/
    }
    
    useEffect(() => {
        init().then(value => filter(value))
    }, []);
    
    const closeCarga = () => {
        setCarga(false)
    }

    useEffect(() => {
        const timer =  setTimeout(closeCarga, 5000);
        return () => clearTimeout(timer); 
    }, []);

    if (!battery && carga)
    return <Grid container direction="row" justify="center" alignItems="center" style={{ width: "290px", height: "220px" }}>
            <CircularProgress size={60}></CircularProgress>
        </Grid>

    return (
        <Paper elevation={0}style={{ width: "90%", height: "220px", borderRadius: "15px" }}>            
            <WidgetBateria valor={battery ? battery : carga} />
        </Paper>
    )

}

